import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQiwiComponent } from './simple-icons-qiwi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQiwiComponent ],
    exports:      [ SimpleIconsQiwiComponent ],
    bootstrap:    []
})
export class SimpleIconsQiwiModule {}
